import * as UI from "@iyk/ui"
import * as React from "react"

import { LogoutButton } from "../../auth/logout-button.tsx"
import { VerifiedProfileIcon } from "./icons.tsx"
import { Sheet } from "./sheet.tsx"

export const UserMenu = (props: UserMenu.Props) => {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <Sheet.Root open={isOpen} onOpenChange={setIsOpen}>
      <Sheet.Trigger asChild>
        <UI.Button type="button" kind="shaded" size="sm">
          <UI.Icon.Profile />
        </UI.Button>
      </Sheet.Trigger>
      <Sheet.Content title="Profile" description="Manage your profile">
        <div className="flex flex-col gap-4 px-4 pt-10 pb-4">
          <div className="flex justify-between border-white/[10%] bg-white/[3%] p-4 rounded">
            <div className="flex items-center gap-2">
              <span className="text-[18px] leading-6 uppercase font-departure-mono">
                {props.username}
              </span>
              <VerifiedProfileIcon />
            </div>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <UI.Icon.Location />
                <span className="text-xs">{props.locationCount}</span>
              </div>
            </div>
          </div>
          <div className="w-full flex flex-col">
            <LogoutButton formClassName={classForMenuAction} buttonClassName="flex-1 text-left" />
          </div>
        </div>
      </Sheet.Content>
    </Sheet.Root>
  )
}

const classForMenuAction = UI.cx(
  "w-full h-12 cursor-pointer text-sm text-gray-11 flex items-center",
)

namespace UserMenu {
  export type Props = {
    userId: string
    username: string
    locationCount: number
  }
}
